/* ModalLoadingRenderer.js */

"use strict";
const Loader = require("@gluenetworks/fancy_loading_mask_gl");

class ModalLoadingRenderer {
    /**
     * Create a renderer for the loading veil.
     * @param model {ModalLoadingComponent} - The model that is bound to this renderer.
     */
    constructor(model) {
        this._model = model;

        this._loader = new Loader({
            darkTheme: true,
            shown: true,
            message: this._model.message,
        });
        this._rootElem = this._loader.renderer.rootElement;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        if (this._hideButton && this._onHideClick) {
            this._hideButton.removeEventListener("click", this._onHideClick);
        }
        if (this._abortButton && this._onAbortClick) {
            this._abortButton.removeEventListener("click", this._onAbortClick);
        }
        return this._loader.shutdown().then(() => {
            this._loader = undefined;
            this._model = undefined;
            this._rootElem = undefined;
            this._buttonRow = undefined;
            this._hideButton = undefined;
            this._abortButton = undefined;
            this._onHideClick = undefined;
            this._onAbortClick = undefined;
        });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise}
     */
    render() {
        if (this._model.showHideButton || this._model.showAbortButton) {
            this._buttonRow = document.createElement("div");
            this._buttonRow.classList.add("fancy-loading-button-row");

            if (this._model.showHideButton) {
                this._hideButton = document.createElement("button");
                this._hideButton.classList.add("fancy-loading-hide-button");
                this._hideButton.innerText = "Hide";
                this._onHideClick = () => this._model.hide();
                this._hideButton.addEventListener("click", this._onHideClick);
                this._buttonRow.appendChild(this._hideButton);
            }

            if (this._model.showAbortButton) {
                this._abortButton = document.createElement("button");
                this._abortButton.classList.add("fancy-loading-abort-button");
                this._abortButton.innerText = this._model.abortLabel;
                this._onAbortClick = () => this._model.abort();
                this._abortButton.addEventListener("click", this._onAbortClick);
                this._buttonRow.appendChild(this._abortButton);
            }

            this._rootElem.appendChild(this._buttonRow);
        }
        return Promise.resolve();
    }

    showProgress(msg) {
        this._loader.showProgress(msg);
    }

    /**
     * Returns the root element of the renderer (the Loader's fancy-loading-mask-gl element).
     * @returns {HTMLElement}
     */
    getRootElement() {
        return this._rootElem;
    }

    get rootElement() {
        return this.getRootElement();
    }

    /*******************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS   */
    /*******************************************/
}

module.exports = ModalLoadingRenderer;
